import { post, postToRails } from 'venuescanner-js/services/api';

export const signIn = data =>
  post('/auth/sign-in', data, { returnData: false });

export const signUp = user =>
  post('/auth/sign-up', { user }, { returnData: false });

export const forgotPassword = data =>
  post('/auth/forgot-password', data, { returnData: false });

export const signOut = async (redirectUrl = '/') => {
  localStorage.removeItem('user');
  await postToRails('/sign-out');
  window.location.href = redirectUrl;
};
